import React from 'react';
import { AlertBanner } from 'app/components/Modal/AlertBanner';

interface SuccessAlertState {
  message: string;
  visible: boolean;
}

export const useSuccessAlert = () => {
  const [successAlert, setSuccessAlert] =
    React.useState<SuccessAlertState | null>(null);

  // Handle moment creation success
  const handleMomentCreateSuccess = React.useCallback((message: string) => {
    setSuccessAlert({ message, visible: true });
    // Auto-hide the alert after 10 seconds
    setTimeout(() => {
      setSuccessAlert(null);
    }, 10000);
  }, []);

  // Handle manual close
  const handleClose = React.useCallback(() => {
    setSuccessAlert(null);
  }, []);

  // Render the alert banner component
  const SuccessAlertBanner = React.useMemo(() => {
    if (!successAlert || !successAlert.visible) return null;

    return (
      <AlertBanner
        variant="informative"
        message={successAlert.message}
        onClose={handleClose}
      />
    );
  }, [successAlert, handleClose]);

  return {
    handleMomentCreateSuccess,
    SuccessAlertBanner
  };
};
